import { FC, useEffect } from 'react';

import { CampaignType } from 'utils/constants/campaign';
import { Settings } from 'utils/constants/dynamicSettings';

import useTrls from 'hooks/translation/useTrls';
import useSettings from 'hooks/useSettings';

import MagritteCompositeSelection from 'components/common/CompositeSelection/CompositeSelection';
import { MagritteFormField } from 'components/common/MagritteFormField/MagritteFormField';
import { getCampaignType } from 'components/CpcFlexibleCreate/CpcForm/AdCampaignInformation/getCampaignType';
import { ErirClassificationInput } from 'components/CpcFlexibleCreate/CpcForm/ErirClassification/ErirClassificationInput';
import ErirClassificationTip from 'components/CpcFlexibleCreate/CpcForm/ErirClassification/ErirClassificationTip/ErirClassificationTip';
import { useErirCatalogData } from 'components/CpcFlexibleCreate/CpcForm/ErirClassification/useErirCatalogData';

import { setClassificationCodeId } from 'store/models/createBanner';
import { useDispatch, useSelector } from 'store/utils';

const Trls = {
    title: 'AdCreate.AdForm.ErirClassification.title',
    legend: 'AdCreate.AdForm.ErirClassification.legend',
    placeholder: 'AdCreate.AdForm.ErirClassification.input.placeholder',
    notFound: 'AdCreate.AdForm.ErirClassification.input.notFound',
    popup: {
        submit: 'AdCreate.AdForm.ErirClassification.Popup.submit',
        cancel: 'AdCreate.AdForm.ErirClassification.Popup.cancel',
        notFound: 'AdCreate.AdForm.ErirClassification.Popup.notFound',
        searchPlaceholder: 'AdCate.AdForm.ErirClassification.Popup.searchPlaceholder',
    },
};

export const ErirClassification: FC = () => {
    const classificationCodeId = useSelector((state) => state.createBanner.classificationCodeId);
    const campaignType = useSelector((state) => state.createCampaign.campaignType);

    const settings = useSettings();
    const dispatch = useDispatch();
    const trl = useTrls();
    const { collection, provider } = useErirCatalogData();

    const isErirClassificationEnabled = settings(Settings.ErirClassificationEnabled);

    const isAdvertisingCampaign = campaignType === CampaignType.Advertising;

    const onChange = (selectedClassificationCodeIds: string[]) => {
        dispatch(setClassificationCodeId(selectedClassificationCodeIds[0] ?? null));
    };

    useEffect(() => {
        void dispatch(getCampaignType());
    }, [dispatch]);

    if (!isErirClassificationEnabled || !isAdvertisingCampaign) {
        return null;
    }

    return (
        <>
            <MagritteFormField
                input={
                    <MagritteCompositeSelection.Root
                        collection={collection}
                        value={[classificationCodeId ?? '']}
                        onChange={onChange}
                    >
                        <ErirClassificationInput provider={provider} />
                        <MagritteCompositeSelection.TreeSelectorModal
                            leavesOnly
                            singleChoice
                            texts={{
                                title: trl(Trls.title),
                            }}
                        />
                    </MagritteCompositeSelection.Root>
                }
                label={trl(Trls.legend)}
                vSpacingBottom={classificationCodeId ? 32 : 24}
            />
            {!classificationCodeId && <ErirClassificationTip />}
        </>
    );
};
